import React from 'react';
import styled from 'styled-components';
import de from '../../../../assets/images/germany.png';
import cz from '../../../../assets/images/czech.png';
import fr from '../../../../assets/images/france.png';
import nl from '../../../../assets/images/holland.png';
import it from '../../../../assets/images/italy.png';
import pl from '../../../../assets/images/poland.png';
import sk from '../../../../assets/images/slovakia.png';
import es from '../../../../assets/images/spain.png';
import ch from '../../../../assets/images/switzerland.png';

export const sourceByCountryCode = {
    de,
    cz,
    fr,
    nl,
    it,
    pl,
    sk,
    es,
    ch,
};

const FlagImg = styled.img`
    width: 20px;
    height: 20px;
`;

const Flag: React.FC<{ show: boolean; src: string }> = ({ show = false, src = '' }) => {
    return show ? (
        <div>
            <FlagImg src={src} />
        </div>
    ) : (
        <div>
            <div />
        </div>
    );
};

export default Flag;
